import { render, staticRenderFns } from "./notifications-handler.vue?vue&type=template&id=b1f1e270&scoped=true&"
import script from "./notifications-handler.vue?vue&type=script&lang=js&"
export * from "./notifications-handler.vue?vue&type=script&lang=js&"
import style0 from "./notifications-handler.vue?vue&type=style&index=0&id=b1f1e270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f1e270",
  null
  
)

export default component.exports